import TalentListPage from '../components/Talent/TalentListPage'

const Trainees = () => {
  return (
    <>
      <title>Trainees | Talent Service</title>
      <TalentListPage talentType="trainee" />
    </>
  )
}

export default Trainees
